export type ArticleAudience = "everyone" | "subscribers" | "paid_subscribers";

export function getArticleAudience(article: any): ArticleAudience {
  const value = article?.attributes?.audience;
  if (value === "subscribers" || value === "paid_subscribers") return value;
  return "everyone";
}

export function isPaidAccessActive(payment: { endedAt?: number } | null | undefined): boolean {
  if (!payment) return false;
  if (typeof payment.endedAt === "number" && payment.endedAt * 1000 < Date.now()) return false;
  return true;
}

export function canAccessArticle(
  article: any,
  access: {
    isLoading: boolean;
    isSiteOwner: boolean;
    isSubscribed: boolean;
    isPaidSubscriber: boolean;
  },
): boolean {
  const audience = getArticleAudience(article);
  if (audience === "everyone") return true;
  if (access.isSiteOwner) return true;
  if (access.isLoading) return false;
  if (audience === "subscribers") return access.isSubscribed;
  return access.isPaidSubscriber;
}
